var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69404 1.12594C7.44448 0.478945 8.55552 0.478945 9.30596 1.12594L9.6419 1.41558C10.012 1.73464 10.486 1.90718 10.9746 1.90065L11.4181 1.89471C12.4089 1.88146 13.26 2.59562 13.419 3.57362L13.4902 4.01143C13.5686 4.49372 13.8208 4.93063 14.1993 5.23967L14.5429 5.52022C15.3103 6.1469 15.5033 7.24106 14.9964 8.09245L14.7695 8.47358C14.5196 8.89344 14.4319 9.39026 14.5232 9.87028L14.6061 10.306C14.7912 11.2794 14.2357 12.2416 13.3001 12.568L12.8813 12.7141C12.42 12.8751 12.0335 13.1994 11.7949 13.6258L11.5783 14.0128C11.0944 14.8775 10.0503 15.2575 9.12387 14.9062L8.70912 14.7489C8.25225 14.5757 7.74775 14.5757 7.29088 14.7489L6.87613 14.9062C5.94967 15.2575 4.90563 14.8775 4.42174 14.0128L4.20511 13.6258C3.96649 13.1994 3.58002 12.8751 3.11867 12.7141L2.69987 12.568C1.76434 12.2416 1.20882 11.2794 1.39391 10.306L1.47677 9.87028C1.56805 9.39026 1.48045 8.89344 1.2305 8.47359L1.0036 8.09245C0.496742 7.24106 0.689671 6.1469 1.45715 5.52022L1.80072 5.23967C2.1792 4.93063 2.43144 4.49372 2.50985 4.01144L2.58102 3.57362C2.74001 2.59562 3.59111 1.88146 4.58186 1.89471L5.02538 1.90065C5.51396 1.90718 5.98803 1.73464 6.3581 1.41558L6.69404 1.12594Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 8L7.33325 10L11.3333 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify2);
export default __webpack_public_path__ + "static/media/verify2.70e132de9a4bbab342e2cf537d21525d.svg";
export { ForwardRef as ReactComponent };